import axios from 'axios'

export default {
    async getReport(reportName,Data){

        //let url = process.env.VUE_APP_REPORT;
        let auth = "Basic " + process.env.VUE_APP_AUTH;
        let reportObj = {"template":{"shortid":reportName},"data":Data};
        //"application/json; charset=utf-8"

        let res = await axios.post(process.env.VUE_APP_REPORT,reportObj,
            {responseType: "arraybuffer",headers: { 'Authorization': auth,'Content-Type': 'application/json; charset=utf-8' }});
        //console.log(res.data)
        return res.data;
    }   
}